import { render } from "./intellectualProperty.vue?vue&type=template&id=3ac781f7"
import script from "./intellectualProperty.vue?vue&type=script&lang=js"
export * from "./intellectualProperty.vue?vue&type=script&lang=js"

import exportComponent from "/home/webiotcpc/dhruvi/Git/tivo/vue-tivo/tivo-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__